import { h, FunctionComponent } from 'preact';
import Modal from '../../../../components/modal/modal';
import Button from '../../../../components/button/button';
import Translate from '../../../../components/translate/translate';
import { useAriaFocusRef } from '../../../../helpers/aria-helper';

interface Props {
	isOpen: boolean;
	onCall: () => void;
	onCancel: () => void;
}

const MaskedPhoneConfirmationModal: FunctionComponent<Props> = ({ isOpen, onCall, onCancel }) => {
	const maskedPhoneRef = useAriaFocusRef(null);

	return (
		<Modal isOpen={isOpen}>
			<div className="masked-phone-confirmation-modal" ref={maskedPhoneRef}>
				<span className="confirmation-title aria-focus" tabIndex={0}>
					<Translate text="TRACKING.WANT_TO_CALL_YOUR_DRIVER" />
				</span>

				<div className="actions">
					<Button className="filled-button" onClick={onCall} testId="masked-phone-call-button">
						<Translate text="GLOBAL.CALL" />
					</Button>

					<Button className="solid-button" onClick={onCancel} testId="masked-phone-cancel-button">
						<Translate text="GLOBAL.CANCEL" />
					</Button>
				</div>
			</div>
		</Modal>
	);
};

export default MaskedPhoneConfirmationModal;
